import React from 'react';
import PropTypes from 'prop-types';
import { DRILL_TYPE } from '@common-packages/drilling';

import { createDrillRoute } from '../../shared/drilling';
import { currencyCellFormatter } from '../../shared/formatters';
import { defaultColumnDefinition } from '../../shared/columnDefinitions';
import {
  LinkCellRendererFactory,
  TextCellRendererFactory,
} from '../../shared/columnDefinitions/cellRenderers';
import getContextAwareUrlParams from '../../utils/getContextAwareUrlParams';

import { categoriesForGenericCategory } from './constants';

const amountFormatter = props => {
  if (props.data.rowInfo.isEmptyRow) {
    return '';
  }

  return currencyCellFormatter({ value: props.value });
};

const amountColumnsDefinition = {
  cellClassRules: {
    'underlined-cell': ({ data }) => data.rowInfo.dataUnderlined,
    'double-underlined-cell': ({ data }) => data.rowInfo.dataDoubleUnderlined,
  },
  cellStyle: {
    textAlign: 'right',
  },
  valueFormatter: amountFormatter,
  width: 150,
};

const extendedDefaultColumnDefinition = {
  ...defaultColumnDefinition,
  sortable: false,
};

const TextRenderer = TextCellRendererFactory({
  getText: ({ valueFormatted }) => valueFormatted || '',
});

const getColumnDefinitions = params => {
  const categoryRendererFactory = categoryIdKey => {
    const Link = props => {
      const isCatDescInCategoriesForGenericCategory = Object.values(
        categoriesForGenericCategory,
      ).some(category => category === props.data.catDesc);

      if (isCatDescInCategoriesForGenericCategory) {
        const GenericCategoryLink = LinkCellRendererFactory({
          getText: ({ valueFormatted }) => valueFormatted,
          getPathName: (value, data) =>
            createDrillRoute(
              {
                drillType: DRILL_TYPE.GENERIC_DRILL,
                categoryId: data[categoryIdKey],
                taxName: params.taxName,
              },
              getContextAwareUrlParams(params),
            ),
        });
        return <GenericCategoryLink {...props} />;
      }
      return <TextRenderer {...props} />;
    };

    Link.propTypes = {
      data: PropTypes.shape({
        catDesc: PropTypes.string,
      }).isRequired,
    };

    return Link;
  };

  const columnDefinitions = [
    {
      ...extendedDefaultColumnDefinition,
      headerName: 'Account',
      field: 'catDesc',
      width: 200,
    },
    {
      ...extendedDefaultColumnDefinition,
      ...amountColumnsDefinition,
      headerName: 'Within',
      field: 'catWithin',
      cellRenderer: categoryRendererFactory('categoryId'),
    },
    {
      ...extendedDefaultColumnDefinition,
      ...amountColumnsDefinition,
      headerName: 'Everywhere',
      field: 'catEverywhere',
      cellRenderer: categoryRendererFactory('everywhereCategoryId'),
    },
  ];

  return columnDefinitions;
};

export default getColumnDefinitions;
